import { request } from '../request';

export async function terminate(id: string, reason: string) {
  return request.post<void>(`/v2/shifts/terminate/${id}`, {
    terminateReason: reason,
  });
}
